import { Component, Input } from '@angular/core';
import { ProdutoLocal } from '../../../core/models/produtos/produto-local';

/**
 * Conteúdo (corpo) do `<ng-template #adicionarItensEstoqueLocal let-modal>` do componente pai
 * (pedido-adicionar-itens-modal.component.html:182-218).
 *
 * Escopo: SOMENTE o `modal-body` (tabela com "Local" e "Estoque" por localidade).
 * O `<ng-template>`, `#adicionarItensEstoqueLocal`, `modal-header` (linhas 183-189),
 * `modal-footer` (linhas 215-217) e o método abridor `modalAdicionarItensEstoqueLocal(content, id_produto)`
 * permanecem intocados no pai. Esta é uma modal read-only — sem mutações, sem `@Output()`.
 *
 * `@ViewChild("adicionarItensEstoqueLocal") adicionarItensEstoqueLocalTemplate` (ts:290)
 * continua funcionando sem alteração pois aponta para o próprio `<ng-template>`, que não se move.
 */
@Component({
  selector: 'app-pedido-itens-modal-estoque-local',
  standalone: false,
  templateUrl: './pedido-itens-modal-estoque-local.component.html',
  styleUrls: ['./pedido-itens-modal-estoque-local.component.scss']
})
export class PedidoItensModalEstoqueLocalComponent {
  /* Lista de locais e estoques do produto (ts:179: `produtoLocais: ProdutoLocal[] = []`). */
  @Input() produtoLocais: ProdutoLocal[] = [];
}
